import React, { useEffect, useState, useRef, useCallback, Fragment } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import {FaThumbsUp, FaThumbsDown, FaCommentAlt} from 'react-icons/fa'
import { imageBaseURL } from '../../services/defaultProps'
import Header from '../../components/Header'
import { FiArrowLeft } from 'react-icons/fi'
import text from '../../constants/Menu'
import Loader from 'react-loader-spinner'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { withWindowSizeListener } from 'react-window-size-listener'
import { useHistory } from 'react-router-dom'
import translation from '../../constants/RememberYou'
import '../../styles/containers/RememberYou.css'
import '../../styles/containers/ListComprasPreview.css'
import useLanguage from '../../hooks/useLanguage'
import { BsPlus } from 'react-icons/bs'
import UploadImageWithTextButton from '../../components/UploadImageWithTextButton'
import API from '../../services/Api'
import { toast } from 'react-toastify'

const RememberYouGridWithoutSizeListener = ({ items, windowSize: { windowWidth }, handleAddImage }) => {
  const renderPhotos = useCallback(() => {
    const { push } = useHistory()
    const language = useLanguage()

    const [imageWidth, setImageWidth] = useState(0)
    const imageRef = useRef(null)

    const navigateToSlider = index => {
      const photos = items.map(item => {
        return {
          id: item.id,
          image: item.image,
          text: item.text,
          textFeedback: item.textFeedback
        }
      })

      push('/rememberyou/carousel', {
        initialPhoto: index,
        photos
      })
    }

    useEffect(() => {
      if (imageRef.current) {
        setImageWidth(imageRef.current.offsetWidth)
      }
    }, [windowWidth])

    return (
      <Fragment>
        <div className='rememberyou-grid-item rememberyou-grid imagegridphotos-item' onClick={handleAddImage} style={{ height: 4 * imageWidth / 3 }}>
          <button className='add-image-button' style={{ width: '100%', height: '100%' }}>
            <BsPlus size={60} color='#e0e0e0' />
          </button>
        </div>
        {items.map((item, index) => (
          <div ref={imageRef} key={item.image} className='imagegridphotos-item listcompras-grid'
            onClick={() => navigateToSlider(index)} style={{ height: 4 * imageWidth / 3 }} >
            <LazyLoadImage src={item.image} effect='blur'
              width='100%'
              height='100%'
              style={{
                objectFit: 'cover',
                objectPosition: 'center'
              }} />
            {item.reasonFeedback && (
              <div className={`remeberyou-item-overlay ${item.reasonFeedback}`}>
                {item.reasonFeedback === 'like' ? (
                  <div className='remeberyou-item-status'>
                    <FaThumbsUp color='white' size={20} />
                    <p>{translation.like[language]}</p>
                  </div>
                ) : item.reasonFeedback === 'dislike' ? (
                  <div className='remeberyou-item-status'>
                    <FaThumbsDown color='white' size={20} />
                    <p>{translation.dislike[language]}</p>
                  </div>
                ) : (
                  <div className='remeberyou-item-status'>
                    <FaCommentAlt color='white' size={20} />
                    <p>{translation.comment[language]}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </Fragment>
    )
  }, [items, windowWidth])

  return (
    <div className='imagegridphotos-container'>
      {renderPhotos()}
    </div>
  )
}

const PerfilGrid = withWindowSizeListener(RememberYouGridWithoutSizeListener)

const RememberYou = props => {
  const { push } = useHistory()

  const language = useLanguage()
  const [loadingReqService, setLoadingReqService] = useState(false)
  const [loadingSendButton, setLoadingSendButton] = useState(false)
  const [addImagePage, setAddImagePage] = useState(false)
  const [imagesToShow, setImagesToShow] = useState([])

  useEffect(() => {
    findRememberYou()
  }, [])

  const handleAddRememberYou = async data => {
    if (!data.text && !data.image) {
      toast.error(translation.addImageOrTextMessage[language])
      return
    }

    const sendData = {
      text: data.text || '',
      image: data.image || null,
      userId: props.user.id,
      consultantId: props.user.consultantId
    }

    setLoadingSendButton(true)
    await API.postNewRememberYou(props.token, sendData)
      .then(async res => {
        await findRememberYou()
        setAddImagePage(false)
        toast.success(translation.sendSuccess[language])
      })
      .finally(() => {
        setLoadingSendButton(false)
      })
  }

  const findRememberYou = async () => {
    setLoadingReqService(true)
    await API.getRememberYouList(props.token)
      .then(res => {
        const data = res
        const rememberYou = data.map(item => {
          return {
            ...item,
            image: imageBaseURL + item.image
          }
        })

        setImagesToShow(rememberYou)
        setAddImagePage(rememberYou.length < 1)
      })
      .finally(() => {
        setLoadingReqService(false)
      })
  }

  const renderAddImageScreen = () => {
    return (
      <div className='rememberyou-empty-innercontainer'>
        <div className='rememberyou-request-service'>
          <p>{translation.notConfig[language]}</p>
        </div>
        <UploadImageWithTextButton onClick={handleAddRememberYou} loadingButton={loadingSendButton} />
      </div>
    )
  }

  return (
    <div className='rememberyou-screen-container'>
      <Header language={language} />
      <div className='rememberyou-screen-innercontainer'>
        <div className='rememberyou-screen-title'>
          <FiArrowLeft onClick={() => {
            if (addImagePage && imagesToShow.length > 0) {
              setAddImagePage(false)
            } else {
              push('/')
            }
          }}
            size={24} color='var(--primary)' className='rememberyou-screen-goback' />
          <p>{text.rememberedYou[language]}</p>
        </div>
        <div className='remeberyou-container'>
          <div className='remeberyou-innercontainer'>
            {(imagesToShow.length > 0 && !addImagePage) ? (
              <PerfilGrid items={imagesToShow} handleAddImage={() => setAddImagePage(true)} />
            ) : (
              <div className='rememberyou-screen-notconfigured'>
                {loadingReqService ? (
                  <Loader
                    type='TailSpin'
                    color='#6d357b'
                    height='50'
                    width='50'
                  />
                ) : (
                  addImagePage && renderAddImageScreen()
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(RememberYou)



// WEBPACK FOOTER //
// ./src/containers/RememberedYou/RememberYou.js